import { render, staticRenderFns } from "./ak1.vue?vue&type=template&id=a2099fb4"
import script from "./ak1.vue?vue&type=script&lang=js"
export * from "./ak1.vue?vue&type=script&lang=js"
import style0 from "./ak1.vue?vue&type=style&index=0&id=a2099fb4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports